export default __webpack_public_path__ + "static/media/2e.0cfac732.jpg";